import { Skeleton } from '@mui/material'
import clsx from 'clsx'
import { FC } from 'react'
import { ClassName } from 'types/props'

import classes from './index.module.scss'

const Wrapper: FC<ClassName> = ({ children, className }) => (
  <div className={clsx(classes.root, className)}>{children}</div>
)
const Header: FC = ({ children }) => <span className={classes.header}>{children}</span>
const Stat: FC = ({ children }) => <span className={classes.stat}>{children ?? '–'}</span>
const StatLoading = () => <Skeleton height="24px" width="80px" />

const RelativeStat: FC<{ statisticNumber }> = ({ children, statisticNumber }) => (
  <span
    className={clsx(classes.relativeStat, {
      [classes.positive]: statisticNumber > 0,
      [classes.neutral]: statisticNumber === 0,
      [classes.negative]: statisticNumber < 0
    })}
  >
    {children}
  </span>
)
const RelativeStatLoading = () => <Skeleton height="23px" width="60px" />
const RelativeLabel: FC = ({ children }) => (
  <span className={classes.relativeLabel}>{children}</span>
)

export const Statistic = {
  Wrapper,
  Header,
  Stat,
  StatLoading,
  RelativeStat,
  RelativeStatLoading,
  RelativeLabel
}
